/**
 * A tile's title row: a 10px pillar swatch (or another leading mark) and the
 * title at 14px/600 (DESIGN.md "Body Emphasis"). Rendered as a div, not a
 * <header>, so a tile outside a sectioning element never becomes a banner
 * landmark.
 */
import clsx from 'clsx'
import { Swatch } from './Swatch'
import type { TileHeaderProps } from './types'

export function TileHeader({ title, category, lead, level = 2, id, aside, className }: TileHeaderProps) {
  const Heading = `h${level}` as 'h2' | 'h3' | 'h4'
  return (
    <div className={clsx('flex min-w-0 items-center gap-2', className)}>
      {category ? <Swatch category={category} /> : lead}
      <Heading id={id} className="m-0 min-w-0 text-body font-semibold leading-[1.29] text-text-primary">
        {title}
      </Heading>
      {aside ? <span className="ml-auto flex flex-none items-center">{aside}</span> : null}
    </div>
  )
}

export default TileHeader
